import React, { FC } from 'react';

interface LoadingScreenProps {
  message: string;
}

export const LoadingScreen: FC<LoadingScreenProps> = ({ message }) => {
  return (
    <div className="loading-message">
      <p>{message}</p>
      <div className="loading-anim"></div>
    </div>
  );
};
